import { IAgentAuthListItem } from "models/Employee/employeeManagement.model";

export const Mapper = (data: any, defaultData: IAgentAuthListItem[]) => {
  const _authList: IAgentAuthListItem[] = defaultData.map((m) => {
    let arr = {
      Description: m.Description,
      IsDisabled: null,
      OptionalFlag: false,
      OrderNo: null,
      Title: m.Title,
      Type: m.Type,
      Value: false,
    };

    return arr;
  });

  _authList.map((f: any) => {
    let df: any = Object.entries(data)
      .filter((x) => x[0] === f.Type)
      .find((q: any) => q);
    f.Value = df[1];
  });
  console.log(
    `newAuthList`,
    _authList.sort((a, b) => a.OrderNo - b.OrderNo)
  );
  return _authList.sort((a, b) => a.OrderNo - b.OrderNo);
};
